import httpClient, { ConexaResponse } from '@/services/httpClient'
import {
  GenerateOtCredentialsResponse,
  OTCredentials,
  LogPreCallTestParams,
  ShortnedTokenData,
  CallAppointmentMonitoring,
} from './video-call-types'

export const inviteToVideoCall = async (
  sessionId: string,
  guestName: string,
): Promise<ConexaResponse<string>> => {
  const response = await httpClient.get(
    `/chamada/compartilhar/link/${sessionId}/${guestName}/true`,
  )
  return response.data
}

export const generateOtCredentials = async (): Promise<OTCredentials> => {
  const response = await httpClient.post<GenerateOtCredentialsResponse>(
    '/integration/app-paciente/chamada/teste',
  )

  return response.data.object
}

export const logPreCallTest = async (
  params: LogPreCallTestParams,
): Promise<void> => {
  const response = await httpClient.post(
    '/integration/app-paciente/atendimento/log-teste-chamada',
    params,
  )

  return response.data.object
}

export const getEnableTranscription = async (
  attendanceId: number,
): Promise<boolean> => {
  const response = await httpClient.get(
    `/v2/atendimento/${attendanceId}/check-professional-permission-transcription-ia`,
  )

  return response?.data?.object
}

export const solveShortnedMeetToken = async (
  token: string,
): Promise<ShortnedTokenData> => {
  const response = await httpClient.get(`/rooms/${token}`)
  return response.data
}

export const callAppointmentMonitoring = async (
  appointmentId: string | number,
): Promise<CallAppointmentMonitoring> => {
  const response = await httpClient.get<CallAppointmentMonitoring>(
    `/calls/appointments/${appointmentId}/monitoring`,
  )

  return response.data
}
